import { useCallback } from "react";

import { useIntl } from "react-intl";
import { useAlert } from "./Alert";

function useCancelWarningAlertInfo() {
  const intl = useIntl();
  const title = intl.formatMessage({
    defaultMessage: "Discard changes?",
    description: "showCancelWarningAlert title",
  });
  const description = intl.formatMessage({
    defaultMessage:
      "You have unsaved changes. Are you sure to discard them and leave the screen?",
    description: "showCancelWarningAlert description",
  });
  const stay = intl.formatMessage({
    defaultMessage: "Don't leave",
    description: "showCancelWarningAlert stay option",
  });
  const leave = intl.formatMessage({
    defaultMessage: "Discard",
    description: "showCancelWarningAlert discard",
  });
  return {
    title,
    description,
    stay,
    leave,
  };
}

export function useShowCancelWarningAlert() {
  const info = useCancelWarningAlertInfo();
  const { alert } = useAlert();
  return useCallback(
    (onCancel: () => void) => {
      alert(info.title, info.description, [
        { text: info.stay, style: "cancel", onPress: () => {} },
        {
          text: info.leave,
          style: "destructive",
          onPress: onCancel,
        },
      ]);
    },
    [alert, info.description, info.leave, info.stay, info.title]
  );
}
